import type { WebsiteTranslatorSettings } from 'widgets/website-translator/src/types';

type CalculateColumnGapProps = {
  style: WebsiteTranslatorSettings['style'];
  itemsLength?: number;
};

export function calculateColumnGap({
  style,
  itemsLength = 1
}: CalculateColumnGapProps) {
  const onlyFlagsStyles = ['style1', 'style2'];
  const moreTwoItems = itemsLength > 2;

  if (!onlyFlagsStyles.includes(style)) {
    return 8;
  }

  if (moreTwoItems) {
    return 10;
  }

  return 16;
}
